import axios from "axios";

const getAll = (documentId, checkpointId, callback) => {
    const config = {
        url: `/api/comments/${documentId}/${checkpointId}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data))
}

const resolve = (data, callback) => {
    const config = {
        url: `/api/comments/${data.id}/resolve`,
        method: 'PUT',
        data: data,
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const save = (data, callback) => {
    const {id} = data;
    const config = {
        url: id ? `/api/comments/${data.id}` : `/api/comments`,
        method: id ? 'PUT': 'POST',
        data: data,
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const remove = (id, callback) => {
    const config = {
        url: `/api/comments/${id}`,
        method: 'DELETE',
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const CommentActions = {
    getAll,
    resolve,
    save,
    remove
}

export default CommentActions